import dayjs from 'dayjs';

export function getEventDates(): (
    dateStart: string,
    duration: number | string,
) => { startDate: dayjs.Dayjs; endDate: dayjs.Dayjs } {
    return (dateStart: string, duration: number | string) => {
        const startDate = dayjs(dateStart);
        return { startDate: startDate, endDate: startDate.add(+duration, 'minute') };
    };
}
